export default {"src":"/_next/static/media/arrow-forward.f621247a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};